import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {FORM} from "../../../components/i18n/i18n";
import {ButtonCancel} from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import {utilHelper} from "../../../jwt/_helpers";
import ReactJson from "react-json-view";
import {setDataToEdit, setEditMode, setEnabledForm, setFormInfo} from "../../../redux/actions/genericActions";
import {saveCategory, updateCategory} from "../../../redux/actions/categoryActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {TT_CLOSE} from "../../../components/i18n/toolTips";
import {GenericButton} from "../../../components/buttons/customButtons";





const LogHistoryForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject } = componentState?.data;

    const [jsonItem, setJsonItem] = useState("{}");

    useEffect(() => {
        try {
            setJsonItem(JSON.parse(domainObject?.data));
        } catch (ignored) {
            setJsonItem("{}");
        }
    }, []);

    const {register} = useForm({
        defaultValues: {
            id: domainObject?.id,
            model: domainObject?.model,
            action: domainObject?.action,
            data: domainObject?.data,
            registerDate: utilHelper.dateFormatter(domainObject?.registerDate),
            ipAddress: domainObject?.ipAddress,
            username: domainObject?.username
        }
    });

    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}

            <div className={'top-right'}>
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_CLOSE}
                    icon={'fa-times'}
                    permission={'search'}
                    onClick={props.onClose}
                />
            </div>
        </CardTitle>
        <CardBody>
            <Form>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label htmlFor="model">Modelo</Label>
                            <Input type="name" name="model"
                                   innerRef={register}
                                   disabled={true}/>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label htmlFor="action">Operación</Label>
                            <Input type="name" name="action"
                                   innerRef={register}
                                   disabled={true}/>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label htmlFor="username">Usuario</Label>
                            <Input type="name" name="username"
                                   innerRef={register}
                                   disabled={true}/>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label htmlFor="registerDate">Fecha</Label>
                            <Input type="name" name="registerDate"
                                   innerRef={register}
                                   disabled={true}/>
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        </CardBody>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label>Datos (JSON)</Label>
                            <ReactJson src={jsonItem} name={domainObject?.model} displayDataTypes={false} />
                        </FormGroup>
                    </Col>
                </Row>
        </CardBody>
    </Card>
}


const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFormInfo,
    setDataToEdit,
    setEnabledForm,
    setEditMode,
    saveCategory,
    updateCategory,
})

export default connect(mapStateToProps, mapActionsToProps)(LogHistoryForm)






/*export default function LogHistoryForm(props) {

    const [domainObject] = useState( props.item );
    const [jsonItem, setJsonItem] = useState("{}");

    useEffect(() => {
        try {
            setJsonItem(JSON.parse(domainObject?.data));
        } catch (ignored) {
            setJsonItem("{}");
        }
    }, []);

    const {register} = useForm({
        defaultValues: {
            id: domainObject?.id,
            model: domainObject?.model,
            action: domainObject?.action,
            data: domainObject?.data,
            registerDate: utilHelper.dateFormatter(domainObject?.registerDate),
            ipAddress: domainObject?.ipAddress,
            username: domainObject?.username
        }
    });

    const setForm = () => {
        props.setForm(null, null, "LIST");
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
            </CardTitle>
            <CardBody>
                <Form>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="model">Modelo</Label>
                                <Input type="name" name="model"
                                       innerRef={register}
                                       disabled={true}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="action">Operación</Label>
                                <Input type="name" name="action"
                                       innerRef={register}
                                       disabled={true}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="username">Usuario</Label>
                                <Input type="name" name="username"
                                       innerRef={register}
                                       disabled={true}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="registerDate">Fecha</Label>
                                <Input type="name" name="registerDate"
                                       innerRef={register}
                                       disabled={true}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Datos (JSON)</Label>
                                <ReactJson src={jsonItem} name={domainObject?.model} displayDataTypes={false} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonCancel onClick={setForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    )
}*/